// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","caption":"_1dJD2pSCq2-UhXWE_3mRfd","borderGrey":"#d5dfdf","textGreen":"#009e66","container":"_1pztnJnsfbKpsxV_7t9lrn","infoContainer":"_2_i1Df1MY-iq1cDzrPixZZ","image":"_3vbONj4o_1HFHZCeFD1Qsa","name":"RYf8hQOCTSxD9U9ammL4n _1dJD2pSCq2-UhXWE_3mRfd","price":"LPZgFTSfbG5G0Vu8K_k_ _1dJD2pSCq2-UhXWE_3mRfd","deleteButton":"_1IQJmf8izC-iIOsiLKhMCt","deleteIcon":"_3bnZet2qsTYMgvjXYKMWK0"};


//////////////////
// WEBPACK FOOTER
// ./src/common/compare-section/product-compare-card/ProductCompareCard.css
// module id = 976
// module chunks = 1